<template>
  <v-app>
    <v-navigation-drawer app :width="360">
      <Drawer />
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Drawer from "./Drawer.vue"

export default {
  components: {
    Drawer,
  },
}
</script>
